import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {ColumnType} from "../table/harbour-dues-rotterdam-pro-forma-column.directive";
import {HarbourDuesRotterdamProformaResponse} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: "app-harbour-dues-rotterdam-pro-forma-invoice",
  templateUrl: "./harbour-dues-rotterdam-pro-forma-invoice.component.html",
  styleUrl: "./harbour-dues-rotterdam-pro-forma-invoice.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HarbourDuesRotterdamProFormaInvoiceComponent {
  protected readonly ColumnType = ColumnType;
  protected readonly proForma = input.required<HarbourDuesRotterdamProformaResponse>();

  protected readonly currency = computed(() => this.proForma().currency || 'EUR');
  protected readonly total = computed(() => this.proForma().proFormaTotal);
  protected readonly vesselData = computed(
    () => this.proForma().portDuesProforma?.vesselProforma ?
      [this.proForma().portDuesProforma?.vesselProforma] : []
  );
  protected readonly cargoData = computed(
    () => this.proForma().portDuesProforma?.cargo?.cargoItems || []
  );
  protected readonly sustainabilityData = computed(
    () => this.proForma().portDuesProforma?.sustainability ?
      [this.proForma().portDuesProforma?.sustainability] : []
  );
  protected readonly wasteData = computed(
    () => this.proForma().waste ?
      [this.proForma().waste] : []
  );
}
